import { Link } from "react-router-dom";
import { Card } from "../components/ui";

export function NotFound() {
  return (
    <div>
      <div className="mb-5">
        <h1 className="text-strong text-2xl font-bold tracking-tight">Seite nicht gefunden</h1>
        <p className="text-dim mt-1.5 text-[15px]">Diese Adresse gibt es in der Anwendung nicht.</p>
      </div>
      <Card>
        <div className="text-dim text-sm">
          Der aufgerufene Pfad existiert nicht.{" "}
          <Link to="/" style={{ color: "var(--color-brand-500)" }}>Zurück zum Cockpit</Link>.
        </div>
      </Card>
    </div>
  );
}
